const wasteCalculatorDetailsPageMessages = {
  WASTE_CALCULATOR_INTERNAL_PAGE: {
    TITLE: 'Waste & Abuse',
    SUB_TITLE: 'Track the amount of waste generated by the healthcare system',
    FOR: 'for',
    COHORT_MEMBERS: 'Cohort Members',
    COHORT_COST: 'Cohort Cost',
    COHORT_CLAIMS: 'Cohort Claims',
    CARD: {
      SUB_TITLE: 'Click on a category to view more info',
      LABELS: ['Members', 'Cost', 'Claims'],
    },
    COST_TREND_CHART: {
      SERIES_NAME: ['Total Cost', 'Claims'],
    },
    FACTORS_DROPDOWN_OPTIONS: [
      'Avoidable Hospital Admissions',
      'Avoidable Hospital Readmissions',
      'Avoidable ED Visits',
      'Avoidable procedures',
      'Avoidable Drugs',
      'Overuse of Imaging',
      'Overuse of Not Otherwise Classified (NOC) drugs',
      'Wastage of Medpharma drugs',
    ],
    WASTAGE_COST_TREND_CHART: {
      TITLE: 'Wastage Cost Trend',
      SUB_TITLE: {
        PART1:
          'This visual shows trend of cost and volume of claims with respect to ',
        PART2: ' in the selected period',
      },
      Y_AXIS_LABEL: 'Cost',
      S_AXIS_LABEL: 'Claims',
    },
    SUB_CATEGORIES_TABLE: {
      TITLE: 'Sub-Categories',
      SUB_TITLE: 'This table shows the sub-catogories under ',
    },
    TOP_PROVIDERS_TABLE: {
      TITLE: 'Top Providers',
      SUB_TITLE:
        'Use the toggle switch on the right to switch between physician and facility',
    },
    TABLE_SORT_PROPS: ['High to Low', 'Low to High'],
    MEMBER_DETAILS: {
      TITLE: 'Member Details',
      SUB_TITLE: 'To see more about the member details click on a member',
    },
    TOGGLE_VALUES: { leftValue: 'Physician', rightValue: 'Facility' },
    RECOMMENDATIONS_TAB: {
      TITLE: 'Waste Calculator',
    },
  },
};
export default wasteCalculatorDetailsPageMessages;
